import { useQuery } from '@apollo/client';
import bundleProduct from 'src/queries/wweBundle.graphql';
import { extracted } from 'src/components/BundleProduct/BundleOptionsProvider';
import { wweBundle, wweBundleVariables } from 'src/queries/__generated__/wweBundle';
import { bundleOptionsFromQuery } from 'src/components/BundleProduct/utils/bundleOptionsFromQuery';
import { cleanBundlePrice } from 'src/components/ProductDetail/utils/product-detail.types';

export const getBundlesFromQueryData = (data: wweBundle | undefined, id: number) => {
    if (!data) return null;

    const bundlePrice = cleanBundlePrice(data.bundleProductDetail);
    const bundleOptions = bundleOptionsFromQuery(data.wweBundle.options.option_id, data.wweBundle.options.options);
    const [firstBundleProductDetails] = data.bundleProductDetail;
    const artworkPriceBreak = {
        customisation_estimates: firstBundleProductDetails?.customisation_estimates,
        setup_charges: firstBundleProductDetails?.setup_charges,
    };

    const bundles = [
        {
            id,
            ...extracted(data.wweBundle, bundleOptions),
            bundleVariants: data.wweBundle?.target_configurable?.variants,
        },
    ];

    return {
        bundles,
        bundlePrice,
        artworkPriceBreak,
    };
};

export const useBundleOptions = (id: number) => {
    const { data } = useQuery<wweBundle, wweBundleVariables>(bundleProduct, {
        variables: { id: String(id), asIntArray: [Number(id)], noAuthorization: true },
        ssr: false,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    });

    return getBundlesFromQueryData(data, id);
};
